const InlineCode = ({ children }) => {
  return (
    <span className="inline-code">
        {children}
    </span>
  )
}

export default InlineCode